module.exports = __webpack_public_path__ + "static/media/gramophone.556f514e.svg";